class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="q"]');
    this.clearButton = this.querySelector('[data-ref="search-clear"]');
    this.predictiveSearchResults = this.querySelector('[data-ref="predictive-search"]');
    this.searchUrl = this.dataset.searchUrl || (typeof Theme !== 'undefined' ? Theme.routes.search_url : '/search');

    this.input.addEventListener('input', () => {
      this.toggleClearButton();
    });

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    if (this.clearButton) {
      this.clearButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.input.value = '';
        this.toggleClearButton();
        this.hide();
        this.input.focus();
      });
    }

    this.toggleClearButton();
  }

  toggleClearButton() {
    if (!this.clearButton) return;
    this.clearButton.hidden = this.input.value.trim().length === 0;
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.hide();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const url = `${Theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product&resources[limit]=6`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.hide();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.appendViewAllLink(searchTerm);
        this.show();
      })
      .catch((error) => {
        this.hide();
        throw error;
      });
  }

  appendViewAllLink(searchTerm) {
    const existing = this.predictiveSearchResults.querySelector('.predictive-search__view-all');
    if (existing) existing.remove();

    const link = document.createElement('a');
    link.href = `${this.searchUrl}?q=${encodeURIComponent(searchTerm)}`;
    link.className = 'predictive-search__view-all';
    link.textContent = `View all results for "${searchTerm}" →`;
    this.predictiveSearchResults.appendChild(link);
  }

  show() {
    this.predictiveSearchResults.style.display = 'block';
  }

  hide() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
